module.exports = __webpack_public_path__ + "static/img/dianxin.dccb586.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dianxin.jpg
// module id = tUhe
// module chunks = 0